import { CHECK_PROMOCODE, CLEAR_PROMOCODE } from './types';

const initialState = {
    promocodeData: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case CHECK_PROMOCODE:
            return {
                ...state,
                promocodeData: action.payload
            }
        case CLEAR_PROMOCODE:
            return {
                ...state,
                promocodeData: []
            }
        default:
            return state;
    }
}